export default "__VITE_ASSET__33a34ade__"